/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getEmptyFormData } from 'helpers/FormDataHelper';
import { getQueryParams } from 'helpers/LocationHelper';
import ContentSpinner from 'components/ui/ContentSpinner';

import ReportApi from 'api/report';
import ChartJSWidget from './ChartJS';
import HtmlViewWidget from './HtmlView';
import DataTable from './DataTable';

const Widget = widget => {
  const report = widget.report || {};
  const history = useHistory();
  const [data, setData] = useState();
  const [isFetching, setFetching] = useState(true);

  const fetchData = async () => {
    setFetching(true);
    const queryParams = getQueryParams();
    const emptyFormData = getEmptyFormData(report.filter_form.schema);
    const params = { ...emptyFormData, ...queryParams };
    const data = await ReportApi.getWidgetData(widget, params);
    setFetching(false);
    setData(data);
  };

  useEffect(() => {
    fetchData();
  }, []);

  useEffect(() => {
    history.listen(async location => {
      await fetchData();
    });
  }, [history]);

  if (isFetching) {
    return <ContentSpinner />;
  }

  if (!data) {
    return null;
  }

  try {
    switch (widget.type) {
      case 'chartjs':
        return <ChartJSWidget {...widget} data={data.data} />;

      case 'htmlview':
        return <HtmlViewWidget {...widget} data={data.data} />;

      case 'datatable':
        return <DataTable {...widget} data={data.data} />;

      default:
        break;
    }

    return null;
  } catch (error) {
    console.error(error);
    return <div>Falha ao carregar widget.</div>;
  }
};

export default Widget;
